import { Link } from "react-router-dom";
import { SiteNav } from "./SiteNav";
import { SiteFooter } from "./SiteFooter";
import { usePageTitle } from "./usePageTitle";

/** The catch-all route: a mistyped address (/shpo) says so, rather than quietly showing the home page. */
export function NotFound() {
  usePageTitle("Page not found · Shelf Garden");
  return (
    <div className="site">
      <SiteNav />
      <div className="site-page nf-page">
        <div className="nf-emblem" aria-hidden>🍂</div>
        <h1 className="site-page-title">That page doesn&apos;t exist</h1>
        <p className="site-page-sub">The address may be mistyped, or the page has moved.</p>
        <Link className="site-btn primary" to="/">Back to the home page</Link>
      </div>
      <SiteFooter />
    </div>
  );
}
